
























/** @format */

import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  name: 'LineCard'
})
export default class LineCard extends Vue {
  // :cardTota="cardTotal" :cardNomal="cardNomal" :cardExpired="cardExpired"
  @Prop({ default: 0 })
  cardTotal: any;
  @Prop({ default: 0 })
  cardNomal: any;
  @Prop({ default: 0 })
  cardExpired: any;
}
